export class Confirm {
    data: any;
    action: string;
    constructor (data,action) {
        this.data = data;
        this.action = action;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/confirm.ts